import React from "react";

import { useFormContext } from "react-hook-form";

import { nameValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function RegistrationLastName(props: {
	labelClassName?: string;
	disabled?: boolean;
}) {
	const { labelClassName, disabled } = props;

	const { getValues, trigger, clearErrors } = useFormContext();

	return (
		<FormInputField
			id="lastName"
			className="form__field"
			name="lastName"
			label="registration:LAST_NAME_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:LAST_NAME_PLACEHOLDER"
			pattern={{
				value: nameValidationPattern,
				message: "registration:INVALID_LAST_NAME",
			}}
			disabled={disabled}
			validate={{
				passValidate: () => {
					if (getValues("password")) {
						trigger("password");
					} else {
						clearErrors("password");
					}
				},
			}}
			required
		/>
	);
}
